import { render } from "./DeepPerformanceCpuData.vue?vue&type=template&id=f917d2da&scoped=true&ts=true"
import script from "./DeepPerformanceCpuData.vue?vue&type=script&lang=ts"
export * from "./DeepPerformanceCpuData.vue?vue&type=script&lang=ts"

import "./DeepPerformanceCpuData.vue?vue&type=style&index=0&id=f917d2da&scoped=true&lang=css"
import "./DeepPerformanceCpuData.vue?vue&type=style&index=1&id=f917d2da&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f917d2da"]])

export default __exports__